//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Leavelist.js";
import html2pdf from "html2pdf.js";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";
var convert = require("decimal-number-to-words");

import unity from "@/unity/unity";

export default {
  name: "invoice",
  data(vm) {
    return {
      check_cus_name: false,
      company_search: "",
      department_search: 0,
      department_list: [],
      company_list: [
        {
          company_name: "บริษัท เดชอุดม จำกัด",
          company_code: "D" 
        },
        {
          company_name: "สำนักงานทนายความ",
          company_code: "L" 
        }
      ],
      bank_name_show: "",
      bank_no_show: "",
      curency_show_tb: "",
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      search_status: "",
      status_search: ["Draft", "Submit"],
      dialogAddS: false,
      dialogAdd: false,
      tax_rate: 0,
      dialogAddData: "1",
      dialogSelect: "1",
      exchange_rate: 1,
      menu: false,
      menu2: false,
      search: "",
      currency_print: "",
      currency_show: "",
      toggleEnable: false,
      dialogSelectPrint: false,
      dataAll: [],
      datefrom: null,
      dateto: null,
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      mDataArray: [],
      authorize: [],
      headers: [
        {
          text: "Receive No.",
          value: "trc_id",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Doc Date",
          value: "date_show",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Customer Name",
          value: "cus_name",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Amount",
          value: "trc_sub_amoumt_s",
          class: "bg-colorth tabletextwhite",
          align: "end",
        },
        {
          text: "Currency",
          value: "currency",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Status",
          value: "status",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Print",
          value: "actions",
          class: "bg-colorth tabletextwhite",
        },
      ],
      payment_by_print: "",
      main_id_print: 0,
      inv_id: 0,
      inv_detail_id: 0,
      tax_detail_rate: 0,
      vat: 0,
      showprint: "",
      showprintDetail: "",
      textamount_total_en: "",
      setlanguage: language.en,
      print_header_list: [
        {
          id: "1",
          com_title: "RECEIPT & TAX INVOICE",
          com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
        },
        {
          id: "2",
          com_title: "RECEIPT",
          com_eng_1: "DEJ-UDOM & ASSOCIATES",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0992000028227/"HEAD OFFICE"`,
        },
      ],
      print_header_list_detail: [
        {
          id: "1",
          com_title: "RECEIPT & TAX INVOICE",
          com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
        },
        {
          id: "2",
          com_title: "RECEIPT",
          com_eng_1: "DEJ-UDOM & ASSOCIATES",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0992000028227/"HEAD OFFICE"`,
        },
      ],
      print_header: null,
      print_detail_header: null,
      print_table_detail: [],
      print_table_Rcdetail: [],
      pageAll: 1,
      pageAllDetail: 1,
      opensummarize: false,
      opensummarizeDetail: false,
      datashowAll: [],
      datashowAllDetail: [],
      dataforshowprpo: [],
      setdatatoshow: [],
      setdatatoshowDetail: [],
      branch_cus: "",
      checklawoffice:false,
      heighttabledetail: "0px",
    };
  },
  components: {
    SuccessDialog,
  },
  async beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
  async created() {},
  beforeUpdate() {},
  computed: {
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed!!!",
        "Please Logout And Login Again!!!",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    if (!this.authorize_view) {
      this.$router.back();
    }

    // ----------------- Check Authorize ---------------------------

    let comp_id = localStorage.getItem(server.COMPANYID);

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    await this.loaddata();
    await this.loadDepartmentByCompanyId();
  },
  methods: {
    async loadDepartmentByCompanyId() {
      let result = await api.getAllDepartment_By_CompanyID(localStorage.getItem(server.COMPANYID));
      this.department_list = result.data;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAddS = status;
      this.text_color = text_color;
    },
    showsearchmore() {
      this.toggleEnable = !this.toggleEnable;
      this.seticonsearchmore.action = !this.seticonsearchmore.action;
      if (this.seticonsearchmore.action === true) {
        this.seticonsearchmore.icon = "mdi mdi-chevron-up";
      } else {
        this.seticonsearchmore.icon = "mdi mdi-chevron-down";
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month - 1}-${day}`;
    },
    findChaege() {

      // console.log('company' + this.company_search)
      // console.log('dep' + this.department_search)
      // console.log('status' + this.search_status)
      // console.log('date from' + this.datefrom)
      // console.log('date to' + this.dateto)

      let data_s = [];
      data_s = this.dataAll;
      if(this.company_search != ""){
        // alert("com")
        data_s = data_s.filter((item) => {
            if (item.company_trc == this.company_search) {
              return item;
            }
        })
      }
      if(this.department_search != 0){
        // alert("dept")
        data_s = data_s.filter((item) => {
          if (item.dep_id == this.department_search) {
              return item;
          }
        })
      }
      if(this.search_status != ""){
        // alert("status")
        data_s = data_s.filter((item) => {
          if (item.status == this.search_status){
              return item;
          }
        })
      }

      if (this.datefrom != null && this.dateto != null) {
        // alert("date")
        data_s = data_s.filter((item) => {
          if (item.date >= this.datefrom && item.date <= this.dateto) {
            return item;
          }
        })
      }


      if( 
        this.company_search == "" &&
        this.department_search == 0 &&
        this.search_status == "" &&
        this.datefrom == null &&
        this.dateto == null
      ){
        data_s = this.dataAll;
      }

      this.mDataArray = data_s;
    },
    // finddatafromdate() {
    //   this.mDataArray = this.dataAll.filter((item) => {
    //     if (this.search_status == "") {
    //       if (this.datefrom != null && this.dateto != null) {
    //         if (item.date >= this.datefrom && item.date <= this.dateto) {
    //           return item;
    //         }
    //       }
    //       if (this.datefrom == null && this.dateto == null) {
    //         return item;
    //       }
    //     } else {
    //       if (this.datefrom != null && this.dateto != null) {
    //         if (
    //           item.date >= this.datefrom &&
    //           item.date <= this.dateto &&
    //           item.status == this.search_status
    //         ) {
    //           return item;
    //         }
    //       }
    //       if (this.datefrom == null && this.dateto == null) {
    //         if (item.status == this.search_status) {
    //           return item;
    //         }
    //       }
    //     }
    //   });
    // },
    async loaddata() {
      const result = await api.getDataReceiveHQ();
      this.dataAll = result.data;
      this.dataAll.forEach((item) => {
        item.trc_sub_amoumt_s = tolocalestringnumber(Number(item.trc_sub_amoumt));
        if (!item.trc_id) {
          item.trc_id = "####";
        }
      });

      this.mDataArray = result.data;
      console.log( "this.mDataArray")
      console.log( this.mDataArray)
      this.$hideLoader();
    },
    OpenDialog(item_id) {
      this.dialogAdd = true;
    },
    async toInvCNforRecrive() {
      let company_inv = "";
      if (this.dialogAddData == "1") {
        company_inv = "D";
      } else if (this.dialogAddData == "2") {
        company_inv = "L";
      } else {
      }
      this.$router.push(`/receive-select-document/${company_inv}`);
    },
    async onClicktoeditRC(id) {
      this.$router.push(`/receive-edit/${id}`);
    },
    async onClicktoPrint(data) {
      if (data.currency_print ==  "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check information!!!",
          "Fail  Currency Null Data!!!",
          "text-h5 red--text text-center"
        );
        return;
      }
      this.dialogSelectPrint = true;
      this.main_id_print = data.id;
      this.currency_print =  data.currency;
      this.vat = data.tax_rate;
      this.exchange_rate = data.exchange_rate;
    },
    async loadRef_TypeRcById() {
      const res_inv_id = await api.getDataReceiveDByIDOne(this.main_id_print);
      console.log("res_inv_id.data");
      console.log(res_inv_id.data);
      this.inv_id = res_inv_id.data[0].inv_hid;
      this.tax_rate = res_inv_id.data[0].tax_rate;
      this.payment_by_print = res_inv_id.data[0].payment_by;
      this.bank_name_show = res_inv_id.data[0].bank_name;
      this.bank_no_show = res_inv_id.data[0].bank_no;
      const res_hresult = await api.getdataByIdInvoice_HRC(
        res_inv_id.data[0].inv_hid
      );

      if (res_hresult.data[0].company_inv == "D") {
        this.print_header = this.print_header_list[0];
        this.checklawoffice = false;
        this.heighttabledetail = "340px";
      } else if (res_hresult.data[0].company_inv == "L") {
        this.print_header = this.print_header_list[1];
        this.checklawoffice = true;
        this.heighttabledetail = "365px";
      }
      if (res_inv_id.data[0].payment_by == "cash") {
        this.print_header.payment_by = "Cash";
      } else if (res_inv_id.data[0].payment_by == "Bank") {
        this.print_header.payment_by = "Transfer";
      } else if (res_inv_id.data[0].payment_by == "cheque") {
        this.print_header.payment_by = "Cheque";
      } else {
        this.print_header.payment_by = "Other";
      }
      this.print_header.payment_detail =
        res_inv_id.data[0].payment_comment;
      this.print_header.inv_id = res_inv_id.data[0].trc_id;

      this.print_header.invoice_date = res_hresult.data[0].date_show;

      this.print_header.wth_rate = res_hresult.data[0].wth_rate;
      this.print_header.tax_rate = this.tax_rate;
      this.print_header.wth_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].wth_rate) / 100
      );
      console.log("this.print_header");
      console.log(this.print_header);
    },
    async loadRef_TypeRcDetailById() {
      const res_inv_id = await api.getDataReceiveDByIDOne(this.main_id_print);
      console.log("res_inv_id.data");
      console.log(res_inv_id.data);
      this.inv_detail_id = res_inv_id.data[0].inv_hid;
      this.tax_detail_rate = res_inv_id.data[0].tax_rate;
      this.payment_by_print = res_inv_id.data[0].payment_by;
      this.bank_name_show = res_inv_id.data[0].bank_name;
      this.bank_no_show = res_inv_id.data[0].bank_no;
      let inv_no = "";
      res_inv_id.data.forEach((item, index) => {
        if (index < res_inv_id.data.length - 1) {
          inv_no = inv_no + item.inv_id + ", ";
        } else {
          inv_no = inv_no + item.inv_id;
        }
      });

      const res_hresult = await api.getdataByIdInvoice_HRC(
        res_inv_id.data[0].inv_hid
      );

      if (res_hresult.data[0].company_inv == "D") {
        this.print_detail_header = this.print_header_list_detail[0];
        this.checklawoffice = false;
        this.heighttabledetail = "340px";
      } else if (res_hresult.data[0].company_inv == "L") {
        this.print_detail_header = this.print_header_list_detail[1];
        this.checklawoffice = true;
        this.heighttabledetail = "365px";
      }
      // alert(inv_no)
      this.print_detail_header.invoice_no = inv_no;
      if (res_inv_id.data[0].payment_by == "cash") {
        this.print_detail_header.payment_by = "Cash";
      } else if (res_inv_id.data[0].payment_by == "Bank") {
        this.print_detail_header.payment_by = "Transfer";
      } else if (res_inv_id.data[0].payment_by == "cheque") {
        this.print_detail_header.payment_by = "Cheque";
      } else {
        this.print_detail_header.payment_by = "Other";
      }
      this.print_detail_header.payment_detail = res_inv_id.data[0].payment_comment;
      this.print_detail_header.inv_id = res_inv_id.data[0].trc_id;

      this.print_detail_header.invoice_date = res_hresult.data[0].date_show;

      this.print_detail_header.wth_rate = res_hresult.data[0].wth_rate;
      this.print_detail_header.tax_rate = this.tax_detail_rate;
      this.print_detail_header.wth_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].wth_rate) / 100
      );

      
      console.log("this.print_header");
      console.log(this.print_detail_header);
    },
    async loadInvSoData() {
      //data in table
      var tmp_inv_data;
      var sub_total = 0;
      // console.log(this.main_id_print)
      const res_inv_rc = await api.getDataPrint(this.main_id_print);
      
      console.log("res_inv_rc.data");
      console.log(res_inv_rc.data);
      tmp_inv_data = res_inv_rc.data;

      tmp_inv_data.forEach((item, index) => {
        var data = {
          no: 0,
          inv_id: "",
          date: null,
          credit_term: 0,
          currency: "",
          amount: 0,
        };

        data.no = index + 1;
        data.inv_id = item.inv_id;
        data.date = item.date_show;
        data.credit_term = item.credit_term;
        data.currency = item.currency;
        data.amount = Number(item.Amount);
        data.amount_s = data.amount + (data.amount * (this.vat / 100));
        this.print_table_detail.push(data);
        sub_total = sub_total + data.amount;
        // console.log("res_inv_rc.data last");
        // console.log(data);
      });

      this.print_header.sub_total = sub_total;
      this.print_header.tax_rate_amount = parseFloat(
        (this.print_header.sub_total * this.vat) / 100
      );
      this.print_header.amount_total = parseFloat(
        this.print_header.sub_total + this.print_header.tax_rate_amount
      );


      if((/^[A-Za-z0-9\s.,'"&-_*]+$/.test(this.print_header.customer_name))){
        this.check_cus_name = true;
      }else{
          // language_check = "";
          // language_check = this.print_header.customer_name.split('',2)
          // if((/^[A-Za-z]+$/.test(language_check[1]))){
          //   this.check_cus_name = true;
          // }else{
          //   this.check_cus_name = false;
          // }
        this.check_cus_name = false;
      }

      if(this.check_cus_name){

        this.textamount_total_en = convert.toWords(this.print_header.amount_total.toFixed(2));
        let setcheckscratch = false;
        this.textamount_total_en = this.textamount_total_en.replace(/\b./g, function(m){ 
          if(m == ","){
            return ""; 
          }
          if(m == "-"){
            setcheckscratch = true
            return m; 
          }else{
            if(setcheckscratch){
              setcheckscratch = false
              return m; 
            }
            setcheckscratch = false
            return m.toUpperCase(); 
          }
        });

      }else{
          // console.log("test : flase")
          //start เปลี่ยนเป็นตัวอ่านไทย 
          // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
          var thaiNumbers = ['', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'];
          var thaiUnits = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน'];

          // แยกตัวจำนวนเต็มและทศนิยมห
          var [integerPart, decimalPart] = this.print_header.amount_total.toString().split('.');
          
          // แปลงส่วนทศนิยมเป็นข้อความไทย (สตางค์)
          let decimalText = '';
          if (decimalPart) {
            decimalText = 'จุด' + decimalPart.split('').map(digit => thaiNumbers[digit]).join('');
          }
          
          // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
          let integerText = '';
          var numArray = integerPart.split('').map(Number);
          numArray.forEach((num, index) => {
            var unit = thaiUnits[numArray.length - index - 1];
            var digit = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArray.length - 2 && numArray.length > 2) {
                integerText += 'เอ็ด' + unit;
              } else if (num === 2 && index === numArray.length - 2 && numArray.length > 2) {
                integerText += 'ยี่' + unit;
              } else {
                integerText += digit + unit;
              }
            }
          });

          // รวมข้อความที่ได้และคืนค่ากลับ
          var result = integerText +  decimalText;
          console.log("result convert:" +  result);
          this.textamount_total_en = result;
      }
        
      console.log("this.print_table_detail");
      console.log(this.print_table_detail);
    },
    async loadInvSoDataOth() {
      //data in table
      var tmp_inv_data;
      var sub_total = 0;
      var gran_total = 0;
      var sub_total_oth = 0;
      var gran_total_oth = 0;
      // console.log(this.main_id_print)
      const res_inv_rc = await api.getDataPrint(this.main_id_print);
      console.log("res_inv_rc.data");
      console.log(res_inv_rc.data);
      tmp_inv_data = res_inv_rc.data;

      tmp_inv_data.forEach((item, index) => {
        var data = {
          no: 0,
          inv_id: "",
          date: null,
          credit_term: 0,
          currency: "",
          amount: 0,
          amount_s: 0,
          amount_s_ex: 0,
        };
        data.no = index + 1;
        data.inv_id = item.inv_id;
        data.date = item.date_show;
        data.credit_term = item.credit_term;
        data.currency = item.currency;
        data.amount = Number(item.Amount);

        data.amount_s = (data.amount + (data.amount * (this.vat / 100))).toFixed(2);
        data.amount_s_ex = Number(data.amount_s) * this.exchange_rate ;
        data.amount_s_ex =  Number(data.amount_s_ex.toFixed(2));

        this.print_table_detail.push(data);

 
        this.curency_show_tb = "";
        this.curency_show_tb = item.currency;

        gran_total_oth = gran_total_oth + Number(data.amount_s);
        gran_total = gran_total + Number(data.amount_s_ex.toFixed(2));

      });

      this.print_header.amount_total_oth = parseFloat(gran_total_oth);
      this.print_header.amount_total = parseFloat(gran_total);

      sub_total_oth = (this.print_header.amount_total_oth / (1 + (this.vat / 100))).toFixed(2) 
      sub_total = (this.print_header.amount_total / (1 + (this.vat / 100))).toFixed(2) 
      this.print_header.sub_total_oth = parseFloat(sub_total_oth);
      this.print_header.sub_total = parseFloat(sub_total);

      
      this.print_header.tax_rate_amount_oth = Number(this.print_header.amount_total_oth - sub_total_oth)
      this.print_header.tax_rate_amount = Number(this.print_header.amount_total - sub_total)

      if((/^[A-Za-z0-9\s.,'"&-_*]+$/.test(this.print_header.customer_name))){
        this.check_cus_name = true;
      }else{
          // language_check = "";
          // language_check = this.print_header.customer_name.split('',2)
          // if((/^[A-Za-z]+$/.test(language_check[1]))){
          //   this.check_cus_name = true;
          // }else{
        this.check_cus_name = false;
          // }
      }

      if(this.check_cus_name){

        this.textamount_total_en = convert.toWords(this.print_header.amount_total.toFixed(2));
        let setcheckscratch =false;
        this.textamount_total_en = this.textamount_total_en.replace(/\b./g, function(m){ 
          if(m == ","){
            return ""; 
          }
          if(m == "-"){
            setcheckscratch = true
            return m; 
          }else{
            if(setcheckscratch){
              setcheckscratch = false
              return m; 
            }
            setcheckscratch = false
            return m.toUpperCase(); 
          }
        });
      }else{
          // console.log("test : flase")
          //start เปลี่ยนเป็นตัวอ่านไทย 
          // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
          var thaiNumbers = ['', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'];
          var thaiUnits = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน'];

          // แยกตัวจำนวนเต็มและทศนิยมห
          var [integerPart, decimalPart] = this.print_header.amount_total.toString().split('.');
          
          // แปลงส่วนทศนิยมเป็นข้อความไทย (สตางค์)
          let decimalText = '';
          if (decimalPart) {
            decimalText = 'จุด' + decimalPart.split('').map(digit => thaiNumbers[digit]).join('');
          }
          
          // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
          let integerText = '';
          var numArray = integerPart.split('').map(Number);
          numArray.forEach((num, index) => {
            var unit = thaiUnits[numArray.length - index - 1];
            var digit = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArray.length - 2 && numArray.length > 2) {
                integerText += 'เอ็ด' + unit;
              } else if (num === 2 && index === numArray.length - 2 && numArray.length > 2) {
                integerText += 'ยี่' + unit;
              } else {
                integerText += digit + unit;
              }
            }
          });

          // รวมข้อความที่ได้และคืนค่ากลับ
          var result = integerText +  decimalText;
          console.log("result convert:" +  result);
          this.textamount_total_en = result;
      }
      // this.print_header.sub_total = sub_total;
      console.log("this.print_table_detail");
      console.log(this.print_table_detail);
    },
    async loadRcData() {
      //data in table
      var tmp_inv_data;
      var sub_total = 0;
      // console.log(this.main_id_print)
      const res_inv_rc = await api.getDataReceiveDByID(this.main_id_print);
      console.log("res_inv_rc.data");
      console.log(res_inv_rc.data);
      tmp_inv_data = res_inv_rc.data;

      tmp_inv_data.forEach((item, index) => {
        var data = {
          description: "",
          quantity: 0,
          amount: 0,
        };

        data.description = item.inv_detail;
        data.quantity = parseFloat(item.inv_qty);
        data.amount = parseFloat(item.inv_lineamount);
        this.print_table_Rcdetail.push(data);
        sub_total = sub_total + parseFloat(item.inv_lineamount);
      });
      this.print_detail_header.sub_total = sub_total;
      this.print_detail_header.tax_rate_amount = parseFloat(
        (this.print_detail_header.sub_total * this.tax_detail_rate) / 100
      );
      this.print_detail_header.amount_total = parseFloat(
        this.print_detail_header.sub_total +
          this.print_detail_header.tax_rate_amount
      );

      //check lag
      if((/^[A-Za-z0-9\s.,'"&-_*]+$/.test(this.print_detail_header.customer_name))){
        this.check_cus_name = true;
      }else{
          // language_check = "";
          // language_check = this.print_detail_header.customer_name.split('',2)
          // if((/^[A-Za-z]+$/.test(language_check[1]))){
          //   this.check_cus_name = true;
          // }else{
        this.check_cus_name = false;
          // }
      }

      if(this.check_cus_name){
        
        this.textamount_total_en = convert.toWords(
          this.print_detail_header.amount_total.toFixed(2)
        );

        let setcheckscratch =false;
        this.textamount_total_en = this.textamount_total_en.replace(/\b./g, function(m){ 
          if(m == ","){
            return ""; 
          }
          if(m == "-"){
            setcheckscratch = true
            return m; 
          }else{
            if(setcheckscratch){
              setcheckscratch = false
              return m; 
            }
            setcheckscratch = false
            return m.toUpperCase(); 
          }
        });
      }else{
        //start เปลี่ยนเป็นตัวอ่านไทย 
        // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
          var thaiNumbers = ['', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'];
          var thaiUnits = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน'];

          // แยกตัวจำนวนเต็มและทศนิยมห
          var [integerPart, decimalPart] = this.print_detail_header.amount_total.toString().split('.');
          
          // แปลงส่วนทศนิยมเป็นข้อความไทย (สตางค์)
          let decimalText = '';
          if (decimalPart) {
            decimalText = 'จุด' + decimalPart.split('').map(digit => thaiNumbers[digit]).join('');
          }
          
          // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
          let integerText = '';
          var numArray = integerPart.split('').map(Number);
          numArray.forEach((num, index) => {
            var unit = thaiUnits[numArray.length - index - 1];
            var digit = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArray.length - 2 && numArray.length > 2) {
                integerText += 'เอ็ด' + unit;
              } else if (num === 2 && index === numArray.length - 2 && numArray.length > 2) {
                integerText += 'ยี่' + unit;
              } else {
                integerText += digit + unit;
              }
            }
          });

          // รวมข้อความที่ได้และคืนค่ากลับ
          var result = integerText +  decimalText;
          console.log("result convert:" +  result);
          this.textamount_total_en = result;
      }

      console.log("this.print_table_Rcdetail");
      console.log(this.print_table_Rcdetail);
    },
    async loadMainInvSoData() {
      // var tmp_inv_data;
      const res_inv_so = await api.getdataByIdInvoice_HRC(this.inv_id);
      console.log('com:' +res_inv_so.data[0].company_inv)
      if (res_inv_so.data[0].company_inv == "D") {
        this.print_header = this.print_header_list[0];
      } else if (res_inv_so.data[0].company_inv == "L") {
        this.print_header = this.print_header_list[1];
      }
      this.currency_show =  res_inv_so.data[0].currency;
      this.print_header.customer_name = res_inv_so.data[0].customer_name;
      // this.print_header.invoice_date = res_inv_so.data[0].date;
      this.print_header.addressall = res_inv_so.data[0].addressall;
      this.print_header.customer_address = res_inv_so.data[0].customer_address;

      this.print_header.province_invoice = res_inv_so.data[0].province_invoice;
      this.print_header.country_invoice = res_inv_so.data[0].country_invoice;
      this.print_header.zipcode_invoice = res_inv_so.data[0].zipcode_invoice;

      this.print_header.period_cover = res_inv_so.data[0].inv_id
        ? res_inv_so.data[0].inv_id
        : res_inv_so.data[0].pinv_id;
      this.print_header.customer_contact_name =
        res_inv_so.data[0].customer_contact_name;
      this.print_header.customer_taxid = res_inv_so.data[0].customer_taxid;
      this.branch_cus = res_inv_so.data[0].customer_branch;
      // alert(this.branch_cus)
    },
    async loadMainRcData() {
      // var tmp_inv_data;
      const res_inv_so = await api.getdataByIdInvoice_HRC(this.inv_detail_id);
      if (res_inv_so.data[0].company_inv == "D") {
        this.print_detail_header = this.print_header_list_detail[0];
      } else if (res_inv_so.data[0].company_inv == "L") {
        this.print_detail_header = this.print_header_list_detail[1];
      }
      this.currency_show =  res_inv_so.data[0].currency;
      this.print_detail_header.customer_name = res_inv_so.data[0].customer_name;
      // this.print_header.invoice_date = res_inv_so.data[0].date;
      this.print_detail_header.addressall = res_inv_so.data[0].addressall;
      this.print_detail_header.customer_address =
        res_inv_so.data[0].customer_address;

      this.print_detail_header.province_invoice =
        res_inv_so.data[0].province_invoice;
      this.print_detail_header.country_invoice =
        res_inv_so.data[0].country_invoice;
      this.print_detail_header.zipcode_invoice =
        res_inv_so.data[0].zipcode_invoice;

      this.print_detail_header.period_cover = res_inv_so.data[0].inv_id
        ? res_inv_so.data[0].inv_id
        : res_inv_so.data[0].pinv_id;
      this.print_detail_header.customer_contact_name =
        res_inv_so.data[0].customer_contact_name;
      this.print_detail_header.customer_taxid = res_inv_so.data[0].customer_taxid;
      // alert(res_inv_so.data[0].customer_taxid)
      this.branch_cus = res_inv_so.data[0].customer_branch;
    },
    async checkcontent() {
      console.log("send data ====");
      console.log(this.print_table_detail);
      this.datashowAll = [];
      // alert(data.length);
      this.setdatatoshow = [];
      let linedetailprpo = 23;
      let datainlineprpo = 80;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;
      let newhllinedetails = 0;
      for (let i = 0; i < this.print_table_detail.length; i++) {
        let stringchecklength = "";
        let lengthofdataforshowprpo = this.print_table_detail[i].inv_id.length;

        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];
        this.print_table_detail[i].no = i + 1;

        for (let j = 0; j < this.print_table_detail[i].inv_id.length; j++) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);
        console.log("data lll");
        console.log(newhllinedetails);
        // if (this.print_table_detail[i].first_item == 1) {
        //   newhllinedetails++;
        // }

        // newhllinedetails = Math.ceil(
        //   this.print_table_detail[i].NAME.length / datainlineprpo
        // );

        // newhllinedetails += addnewbutget;
        getnewdata.push(this.print_table_detail[i]);
        console.log(
          `${hllinedetails} +${newhllinedetails} +${linedetailprpo} +${i}`
        );
        if (hllinedetails + newhllinedetails > linedetailprpo) {
          console.log(i + " ============== " + this.print_table_detail.length);
          this.setdatatoshow[this.pageAll - 1] = getdata;
          this.pageAll++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.print_table_detail[i]);
          hllinedetails += newhllinedetails;
          if (i == this.print_table_detail.length - 1) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.print_table_detail[i]);

          if (i == this.print_table_detail.length - 1) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        }
      }
      this.opensummarize = true;
      console.log(this.pageAll);
      console.log("showwwwwwwwwwwwwwwwwwwww");
      console.log(this.setdatatoshow);

      this.setdatatoshow.forEach((item, iitem) => {
        console.log(item);
        console.log(iitem + " " + this.setdatatoshow[0].length);
        if (iitem == this.setdatatoshow.length - 1) {
          item[this.setdatatoshow[iitem].length - 1].lastdata = "lastindex";
        }

        this.datashowAll.push(item);
      });
      console.log("this.datashowAll");
      console.log(this.datashowAll);
    },
    async checkcontentdetail() {
      console.log("send data ====");
      console.log(this.print_table_Rcdetail);
      this.datashowAllDetail = [];
      // alert(data.length);
      this.setdatatoshowDetail = [];
      let linedetailprpo = 23;
      let datainlineprpo = 80;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAllDetail = 1;
      let newhllinedetails = 0;
      for (let i = 0; i < this.print_table_Rcdetail.length; i++) {
        let stringchecklength = "";
        let lengthofdataforshowprpo = this.print_table_Rcdetail[i].description
          .length;

        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];
        this.print_table_Rcdetail[i].no = i + 1;

        for (
          let j = 0;
          j < this.print_table_Rcdetail[i].description.length;
          j++
        ) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);
        console.log("data lll");
        console.log(newhllinedetails);

        getnewdata.push(this.print_table_Rcdetail[i]);
        console.log(
          `${hllinedetails} +${newhllinedetails} +${linedetailprpo} +${i}`
        );
        if (hllinedetails + newhllinedetails > linedetailprpo) {
          console.log(
            i + " ============== " + this.print_table_Rcdetail.length
          );
          this.setdatatoshowDetail[this.pageAllDetail - 1] = getdata;
          this.pageAllDetail++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.print_table_Rcdetail[i]);
          hllinedetails += newhllinedetails;
          if (i == this.print_table_Rcdetail.length - 1) {
            this.setdatatoshowDetail[this.pageAllDetail - 1] = getdata;
            getdata = [];
          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.print_table_Rcdetail[i]);

          if (i == this.print_table_Rcdetail.length - 1) {
            this.setdatatoshowDetail[this.pageAllDetail - 1] = getdata;
            getdata = [];
          }
        }
      }
      this.opensummarizeDetail = true;
      console.log(this.pageAllDetail);
      console.log("showwwwwwwwwwwwwwwwwwwww");
      console.log(this.setdatatoshowDetail);

      this.setdatatoshowDetail.forEach((item, iitem) => {
        console.log(item);
        console.log(iitem + " " + this.setdatatoshowDetail[0].length);
        if (iitem == this.setdatatoshowDetail.length - 1) {
          item[this.setdatatoshowDetail[iitem].length - 1].lastdata =
            "lastindex";
        }

        this.datashowAllDetail.push(item);
      });
      console.log("this.datashowAllDetail");
      console.log(this.datashowAllDetail);
    },
    async exportToPDF() {
      // this.$refs.html2Pdf.generatePdf();

      this.showprint = "";
      let element = document.getElementById("mydivhtmltobase");
      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function(pdf) {
          console.log(pdf);
          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          return pdf.output("bloburl");
        });
      // console.log(abcd);
      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      this.showprint = "display:none;";

      return;
    },
    async exportToPDFDetail() {
      // this.$refs.html2Pdf.generatePdf();

      this.showprintDetail = "";
      let element = document.getElementById("mydivhtmltobaseDetail");
      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function(pdf) {
          console.log(pdf);
          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          return pdf.output("bloburl");
        });
      // console.log(abcd);
      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      this.showprintDetail = "display:none;";

      return;
    },
    async printReceive() {
      if (this.dialogSelect == "1") {
        // alert(this.currency_print)
        this.datashowAll = [];
        this.print_table_detail = [];
        this.dialogSelectPrint = false;
        this.$showLoader();
        await this.loadRef_TypeRcById();
        await this.loadMainInvSoData();
        if(this.currency_print == "THB"){
          await this.loadInvSoData();    
        }else{
          await this.loadInvSoDataOth(); 
        }
        await this.checkcontent();
        await this.exportToPDF();
        this.$hideLoader();
      } else {
        this.datashowAllDetail = [];
        this.print_table_Rcdetail = [];
        this.dialogSelectPrint = false;
        this.$showLoader();
        await this.loadRef_TypeRcDetailById();
        await this.loadMainRcData();
        await this.loadRcData();
        await this.checkcontentdetail();
        await this.exportToPDFDetail();
        this.$hideLoader();
      }
    },
  },
};
